import {
  addHtmlElementClass,
  addHtmlElementEventListener,
  removeHtmlElementClass,
  renderWebComponent,
  string2obj,
  removeHtmlChildren,
  getHtmlElement,
  appendHtmlElementChild,
  isDefined,
  sanitize,
  setHtmlElementContent
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import toggleStyles from '../../styles/toggle.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";


export class SubmissionListTypeComponent extends HTMLElement {
  props = {};

  showMiddlemanPrices = true;

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }

  connectedCallback() {
    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList));
    addHtmlElementEventListener(this.shadowRoot, 'close_pricing_update_notice', 'click', () => {
      addHtmlElementClass(this.shadowRoot, 'pricing_update', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'pricing_update', 'd-flex');
    });
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    this.props.submissionList = { ...submissionList};
    this.refreshInterface();
  }


  // Funzione che esegue l'update tramite richiesta http al server di determinati parametri della submission list,
  // quali ad esempio il tipo di servizio richiesto dall'utente per tutti i suoi articoli
  updateSubmissionList = (keys, values) => {
    const url = `/submission_lists/${this.props.submissionList.id}`;

    const body = {}
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const value = sanitize(values[i]);
      this.props.submissionList[key] = value;
      body[key] = value;
    }

    fetch(url + ".json", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok)
          throw Error("An error occour during saving data on the database");
        else
          return response.json();
      })
      .then((submissionList) => {
        if (keys.includes('service_type') && this.props.submissionList.items_count > 0 &&
           (!submissionList.unavailable_expedit_home_pick_up || !['pro', 'fast'].includes(submissionList.service_type))) {
          removeHtmlElementClass(this.shadowRoot, 'pricing_update', 'd-none');
          addHtmlElementClass(this.shadowRoot, 'pricing_update', 'd-flex');
        } else {
          removeHtmlElementClass(this.shadowRoot, 'pricing_update', 'd-flex');
          addHtmlElementClass(this.shadowRoot, 'pricing_update', 'd-none');
        }

        this.eventBus.publish('updated-submission-list-state', submissionList);
        this.eventBus.publish('render-new-success-flash-message', null);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        this.eventBus.publish('render-modal', {error: true});
      });
  }


  refreshInterface() {
    if (this.props.submissionList.available_services.length > 0) {
      removeHtmlElementClass(this.shadowRoot, 'available_services_title', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'available_services_title', 'd-flex');
    } else {
      removeHtmlElementClass(this.shadowRoot, 'available_services_title', 'd-flex');
      addHtmlElementClass(this.shadowRoot, 'available_services_title', 'd-none');
    }

    const bannersContainer = document.createElement('template');
    let banners = '';
    for (let i = 0; i < this.props.submissionList.available_services.length; i++) {
      const availableService = this.props.submissionList.available_services[i];
      const selected = availableService === this.props.submissionList.service_type;
      banners = banners +
        `<div class="col-12 px-sm-1 py-2 position--relative service-col">
          ${
            ['pro', 'fast'].includes(availableService) && this.props.submissionList.unavailable_expedit_home_pick_up ?
              `<img src="/images/sold_out.png"
                  id="sold_out_expedit_service_banner_img1"
              />`
            :
                ''
          }
          <div class="${selected ? 'bg-aig-gradient-light py-4 px-3 selected' : 'border-solid opacity-0_4 p-3'} service-banner br-8px cursor-pointer h-100" id="service_${availableService}">
            <div class="d-flex justify-content-center text-center">
              <b>
                <span class="service-text-full">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.title`)}</span>
                <span class="service-text-compact">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.titleCompact`)}</span>
              </b>
            </div>

            <div class="mt-3 service-bullets">
              <div class="d-flex mb-1">
                <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1">
                <div class="pl-2">
                  <span class="service-text-full">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.bullet1`)}</span>
                  <span class="service-text-compact">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.bullet1Compact`)}</span>
                </div>
              </div>
              <div class="service-bullets-extra">
                <div class="d-flex mb-1">
                  <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1">
                  <div class="pl-2">
                    <span class="service-text-full">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.bullet2`)}</span>
                    <span class="service-text-compact">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.bullet2Compact`)}</span>
                  </div>
                </div>
                <div class="d-flex mb-1">
                  <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1">
                  <div class="pl-2">
                    <span class="service-text-full">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.bullet3`)}</span>
                    <span class="service-text-compact">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${availableService}.bullet3Compact`)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`;
    }

    bannersContainer.innerHTML = banners;
    removeHtmlChildren(getHtmlElement(this.shadowRoot, 'available_services_container'));
    appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'available_services_container'), bannersContainer.content.cloneNode(true));

    for (const availableService of this.props.submissionList.available_services)
      addHtmlElementEventListener(this.shadowRoot, `service_${availableService}`, 'click', (e) => {
        if (availableService === this.props.submissionList.service_type) return;

        // Toggle ottimistico delle classi sulla tessera cliccata (nessun rebuild qui): così
        // su mobile l'espansione a fisarmonica (title + tutti i bullet) viene animata dalle
        // transizioni CSS. Il rebuild autorevole arriva col responso del server.
        const container = getHtmlElement(this.shadowRoot, 'available_services_container');
        container.querySelectorAll('.service-banner').forEach((el) => {
          el.classList.remove('bg-aig-gradient-light', 'py-4', 'px-3', 'selected');
          el.classList.add('border-solid', 'opacity-0_4', 'p-3');
        });
        const chosen = getHtmlElement(this.shadowRoot, `service_${availableService}`);
        chosen.classList.remove('border-solid', 'opacity-0_4', 'p-3');
        chosen.classList.add('bg-aig-gradient-light', 'py-4', 'px-3', 'selected');

        if (['pro', 'fast'].includes(availableService) && !isDefined(this.props.submissionList.grader_company_home_pick_up_method_id) && isDefined(this.props.submissionList.grader_company.home_pick_up_method?.id))
          this.updateSubmissionList(['service_type', 'grader_company_home_pick_up_method_id'], [availableService, this.props.submissionList.grader_company.home_pick_up_method?.id]);
        else
          this.updateSubmissionList(['service_type'], [availableService]);
      }, true);

    if (['pro', 'fast'].includes(this.props.submissionList.service_type) && this.props.submissionList.unavailable_expedit_home_pick_up) {
      removeHtmlElementClass(this.shadowRoot, 'unavailable_pro_service_container', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'unavailable_pro_service_container', 'd-block');

      const serviceType = this.props.submissionList.service_type;
      const bannersContainer = document.createElement('template');
      bannersContainer.innerHTML = `
        <img src="/images/sold_out.png"
            id="sold_out_expedit_service_banner_img2"
        />
        <div class="row w-100 m-auto bg-aig-gradient-light br-8px shadow p-3">
          <div class="col-12 col-xl-2"></div>
          <div class="col-12 col-xl-10 d-block px-4 px-lg-5 pt-3 pt-xl-0">
            <p>${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${serviceType}.serviceUnavailable`).replaceAll(':grader_company_name', this.props.submissionList.grader_company.meta_name)}</p>
            ${
              isDefined(this.props.submissionList.available_expedit_service_notified_at) ?
                `<p class="mb-0">${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${serviceType}.serviceUnavailableNotified`)}</p>`
              :
                `<p class="mb-0">
                  ${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${serviceType}.serviceUnavailableReminder`)}&nbsp;
                  <span class="text-aiBlue cursor-pointer" id="activize_pro_service_notification">
                    ${I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${serviceType}.serviceUnavailableNotify`)}
                  </span>
                </p>`
            }
          </div>
        </div>
      `;

      removeHtmlChildren(getHtmlElement(this.shadowRoot, 'unavailable_pro_service_container'));
      appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'unavailable_pro_service_container'), bannersContainer.content.cloneNode(true));

      addHtmlElementEventListener(this.shadowRoot, 'activize_pro_service_notification', 'click', (e) => this.updateSubmissionList(['available_expedit_service_notified_at'], [new Date(Date.now() + 86400000)]), true);

      removeHtmlElementClass(this.shadowRoot, "special_pricing_notice", "d-block");
      addHtmlElementClass(this.shadowRoot, "special_pricing_notice", "d-none");
    } else {
      addHtmlElementClass(this.shadowRoot, 'unavailable_pro_service_container', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'unavailable_pro_service_container', 'd-block');

      // Gestisco il rendering sull'interfaccia grafica del banner che informa l'utente del prezzo
      // promo lancio per il servizio FAST fino alla data di fine promozione
      const fastPromoEndDate = this.props.submissionList.fast_promo_end_date;

      if (this.props.submissionList.service_type === 'fast' && isDefined(fastPromoEndDate)) {
        removeHtmlElementClass(this.shadowRoot, "special_pricing_notice", "d-none");
        addHtmlElementClass(this.shadowRoot, "special_pricing_notice", "d-block");
        const specialPricingMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.specialPricing.message', { date: fastPromoEndDate });
        setHtmlElementContent(this.shadowRoot, "special_pricing_message", specialPricingMessage);
      } else {
        removeHtmlElementClass(this.shadowRoot, "special_pricing_notice", "d-block");
        addHtmlElementClass(this.shadowRoot, "special_pricing_notice", "d-none");
      }
    }
  }




  render() {
    const html = ` 
      <div class="row d-none justify-content-center text-center text-aig-gradient mb-0 mt-4 pb-0" id="available_services_title">
        <h2 class="mb-0"><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.serviceType.title')}</b></h2>
      </div>
      
      <div class="row d-flex justify-content-center align-items-center align-items-sm-stretch flex-wrap flex-sm-nowrap w-100 mx-auto" id="available_services_container"></div>
      
      <!-- SEZIONE INFORMATIVA SUL SERVIZIO PRO NON PIÙ DISPONIBILE -->
      <div class="row d-none w-100 mx-auto my-3 position--relative" id="unavailable_pro_service_container"></div>

      <!-- SEZIONE INFORMATIVA SUL PREZZO PROMO LANCIO PER IL SERVIZIO FAST -->
      <div class="d-none text-center bg-aig-gradient-light br-8px shadow mx-0 p-3 mt-4" id="special_pricing_notice">
        <h5 class="my-0 text-aig-gradient">
          <b id="special_pricing_message"></b>
        </h5>
      </div>

      <!-- SEZIONE INFORMATIVA SULL'AGGIORNAMENTO PREZZI A SEGUITO DEL NUOVO SERVIZIO SCELTO DALL'UTENTE -->
      <div class="row d-none w-100 mx-auto mt-3 bg-aig-gradient-light br-8px p-3 position-relative" id="pricing_update">
        <p class="mb-0 mt-1">
          ${I18n.t('js.editSubmissionListPage.webComponent.draft.serviceType.pricingUpdate')}
        </p>
        
        <img src="/images/icons/gray/close.svg" 
            id="close_pricing_update_notice"
            width="15" height="15" 
            class="position-absolute cursor-pointer"
            style="top: 10px; right: 10px"
        />
      </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, toggleStyles, submissionListsStyles]);
    this.refreshInterface();
  }
}

window.customElements.define("submission-list-type-component", SubmissionListTypeComponent);